export default {
  auth: {
    isLoggedIn: false,
    error: null,
    token: null,
  },
  me: null,
  authStatus: 'pending',
  types: {
    fetched: false,
    list: [],
    selected: null,
  },
  headers: [],
  projects: {
    fetched: false,
    fetching: false,
    list: [],
    selected: null,
  },
  segments: {
    fetched: false,
    fetching: false,
    list: [],
    selected: null,
  },
  reports: {
    fetched: false,
    fetching: false,
    list: [],
    selected: null,
  },
}



// WEBPACK FOOTER //
// ./state.js